import Dashboard from 'domain/entity/dashboard';
import { Result } from 'domain/types';
import {
    UpdateDashboardAccessClient,
    UpdateDashboardFrameClient,
    UpdateDashboardNameClient,
    UpdateDashboardPinClient,
    UpdateDashboardStarClient,
} from 'use-case/dashboard/update/updateDashboardClient';
import { UpdateDashboardAccessCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardAccessCriteria';
import { UpdateDashboardFrameCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardFrameCriteria';
import { UpdateDashboardNameCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardNameCriteria';
import { UpdateDashboardPinCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardPinCritera';
import { UpdateDashboardStarCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardStarCriteria';

export type UpdateDashboardResult = Result<Dashboard>;
export type UpdateDashboardName = (criteria: UpdateDashboardNameCriteria) => Promise<UpdateDashboardResult>;
export type UpdateDashboardStar = (criteria: UpdateDashboardStarCriteria) => Promise<UpdateDashboardResult>;
export type UpdateDashboardAccess = (criteria: UpdateDashboardAccessCriteria) => Promise<UpdateDashboardResult>;
export type UpdateDashboardPin = (criteria: UpdateDashboardPinCriteria) => Promise<UpdateDashboardResult>;
export type UpdateDashboardFrame = (criteria: UpdateDashboardFrameCriteria) => Promise<UpdateDashboardResult>;

export const updateDashboardNameUseCase = (updateDashboardNameClient: UpdateDashboardNameClient): UpdateDashboardName => (
    criteria: UpdateDashboardNameCriteria
): Promise<UpdateDashboardResult> => updateDashboardNameClient(criteria);

export const updateDashboardStarUseCase = (updateDashboardStarClient: UpdateDashboardStarClient): UpdateDashboardStar => (
    criteria: UpdateDashboardStarCriteria
): Promise<UpdateDashboardResult> => updateDashboardStarClient(criteria);

export const updateDashboardAccessUseCase = (updateDashboardAccessClient: UpdateDashboardAccessClient): UpdateDashboardAccess => (
    criteria: UpdateDashboardAccessCriteria
): Promise<UpdateDashboardResult> => updateDashboardAccessClient(criteria);

export const updateDashboardPinUseCase = (updateDashboardPinClient: UpdateDashboardPinClient): UpdateDashboardPin => (
    criteria: UpdateDashboardPinCriteria
): Promise<UpdateDashboardResult> => updateDashboardPinClient(criteria);

export const updateDashboardFrameUseCase = (updateDashboardFrameClient: UpdateDashboardFrameClient): UpdateDashboardFrame => (
    criteria: UpdateDashboardFrameCriteria
): Promise<UpdateDashboardResult> => updateDashboardFrameClient(criteria);